export const Global = {
    DINGDING_SCAN_URL:"https://authssoapi.mykeying.com",// 钉钉扫码登录接口地址
    PRO_API_DOMAIN: "https://authssoapi.mykeying.com", // 正式环境API请求地址
    DEV_API_DOMAIN: "http://180.168.219.115:60003", // 测试环境API请求地址
    LOCAL_API_DOMAIN: "https://localhost:44313", // 本地环境API请求地址
    DEV_DDCODE_LOGIN_API_DOMAIN:"http://180.168.219.114:6088",// 钉钉扫码统一回调地址
    PRO_DDCODE_LOGIN_API_DOMAIN:"https://open.mykeying.com"// 钉钉扫码统一回调地址
}
export const DomainType = {
    SSO_TYPE: "sso",
    API_TYPE: "api",
    BP_TYPE: "bp",
}
export const EnvType = {
    PRO: "pro",
    DEV: "dev",
    TEST: "test"
}

export const Constants = {
    DEV_FEISHU_APP_ID: "cli_aab49c20b37c5bd5",
    PRO_FEISHU_APP_ID: "cli_aab6490e01781be0",
}